import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import SettingsPage from './pages/SettingsPage';
import SettingsMenu from './components/SettingsMenu';

function App() {
  const [webhookUrl, setWebhookUrl] = useState('');

  useEffect(() => {
    // Load webhook URL from localStorage on app start
    const savedWebhookUrl = localStorage.getItem('n8n_webhook_url');
    if (savedWebhookUrl) {
      setWebhookUrl(savedWebhookUrl);
    }
  }, []);

  const handleConfigSave = (url) => {
    setWebhookUrl(url);
  };

  return (
    <Router>
      <div className="App">
        <header className="app-header">
          <div className="header-content">
            <div className="header-text">
              <h1>AI-Powered Resume Customization Engine</h1>
              <p>Transform your resume to match any job posting instantly</p>
            </div>
            {webhookUrl && <SettingsMenu />}
          </div>
        </header>

        <main className="app-main">
          <div className="container">
            <Routes>
              <Route 
                path="/" 
                element={
                  webhookUrl ? (
                    <HomePage webhookUrl={webhookUrl} />
                  ) : (
                    <Navigate to="/settings" replace />
                  )
                } 
              />
              <Route 
                path="/settings" 
                element={
                  <SettingsPage 
                    onConfigSave={handleConfigSave}
                    webhookUrl={webhookUrl}
                  />
                } 
              />
            </Routes>
          </div>
        </main>

        <footer className="app-footer">
          <p>© 2026 AI Resume Customization Tool • Powered by N8N & AI</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;